import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent, reactive } from 'vue';
export default defineComponent({
  name: 'NavHeader',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  emits: ['change'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var reactiveList = reactive(props.list);
    reactiveList[0].active = true;

    var onClickItem = function onClickItem(item) {
      reactiveList.forEach(function (i) {
        return i.active = i.code === item.code;
      });
      emit('change', item);
    };

    return {
      reactiveList: reactiveList,
      onClickItem: onClickItem
    };
  }
});